import React from "react";
import { Handle, Position } from 'reactflow';
import useSyncNodeInternals from '../Components/useSyncNodeInternals';

import { LuTags } from "react-icons/lu";
import NodeCardShell from '../Components/NodeCardShell';

const TAGS_NODE_COLOR = '#5BC0DE';

const Tags = ({ data, isConnectable, id, selected }) => {
    useSyncNodeInternals(id, `${data.saved}~${data.first}`);

    const tagTitles = (data.tags || []).map((t) => t?.title).filter(Boolean);
    const tagsSummary = tagTitles.join(', ');

    return (
        <NodeCardShell
          icon={LuTags}
          color={TAGS_NODE_COLOR}
          typeName="Etiquetas"
          title={data.title ?? 'Etiquetar'}
          summary={tagsSummary}
          trigger={data.user_response}
          error={data?.error}
          selected={selected}
          handles={
            <>
              {data.saved && (
                <Handle
                  type="target"
                  position={Position.Top}
                  isConnectable={isConnectable}
                  id={`target-${id}`}
                  style={{ backgroundColor: TAGS_NODE_COLOR }}
                />
              )}
              {data.saved && (
                <Handle
                  type="source"
                  position={Position.Bottom}
                  id={`source-${id}`}
                  isConnectable={isConnectable}
                  style={{ backgroundColor: TAGS_NODE_COLOR }}
                />
              )}
            </>
          }
        />
    )
}

export default React.memo(Tags);